module.exports = __webpack_public_path__ + "static/paragraph-4-mobile-894f2dfb220b4b5bedd220c99a28b1f9.svg";